export default __webpack_public_path__ + "static/media/Core-Values-02.9d3a38a4.png";